<template>
  <v-card-text class="step-widget" :style="containerStyle">
    <div class="step-widget__value" :style="valueStyle">
      {{ Display(value) }}
    </div>

    <div class="step-widget__buttons" :style="buttonsStyle">
      <v-btn
        class="step-widget__btn"
        color="green"
        :style="buttonStyle"
        v-on:click.native="
          up();
          datasend(value);
        "
      >
        +
      </v-btn>

      <v-btn
        class="step-widget__btn"
        color="red"
        :style="buttonStyle"
        v-on:click.native="
          down();
          datasend(value);
        "
      >
        -
      </v-btn>
    </div>
  </v-card-text>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["widget"],

  data() {
    return {
      value: 0,
      min: 0,
      max: 100,
      step: 1,
      decimal: 0,
    };
  },

  computed: {
    widgetWidth() {
      return Number(this.widget?.size?.w) || 180;
    },

    widgetHeight() {
      return Number(this.widget?.size?.h) || 160;
    },

    contentHeight() {
      return Math.max(70, this.widgetHeight - 58);
    },

    scaleBase() {
      return Math.min(this.widgetWidth, this.contentHeight * 1.8);
    },

    valueFontSize() {
      return this.clamp(Math.round(this.scaleBase * 0.18), 22, 74);
    },

    buttonFontSize() {
      return this.clamp(Math.round(this.scaleBase * 0.18), 22, 68);
    },

    buttonHeight() {
      return this.clamp(Math.round(this.contentHeight * 0.36), 44, 92);
    },

    buttonWidth() {
      return this.clamp(Math.round((this.widgetWidth - 34) / 2), 52, 150);
    },

    buttonGap() {
      return this.clamp(Math.round(this.widgetWidth * 0.045), 8, 22);
    },

    containerStyle() {
      return {
        height: `${this.contentHeight}px`,
        padding: `${this.clamp(Math.round(this.scaleBase * 0.035), 6, 16)}px`,
      };
    },

    valueStyle() {
      return {
        fontSize: `${this.valueFontSize}px`,
        lineHeight: "1.08",
      };
    },

    buttonsStyle() {
      return {
        gap: `${this.buttonGap}px`,
      };
    },

    buttonStyle() {
      return {
        width: `${this.buttonWidth}px`,
        minWidth: `${this.buttonWidth}px`,
        height: `${this.buttonHeight}px`,
        fontSize: `${this.buttonFontSize}px`,
        lineHeight: "1",
      };
    },
  },

  methods: {
    ...mapActions(["doPublish"]),

    clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    },

    getParam(name, fallback) {
      const value = this.widget?.params?.[name];
      const numberValue = Number(value);
      return Number.isFinite(numberValue) ? numberValue : fallback;
    },

    up() {
      this.value = Number(this.value) + this.getParam("step", 1);
      if (this.value > this.getParam("max", 100)) {
        this.value = this.getParam("max", 100);
      }
    },

    down() {
      this.value = Number(this.value) - this.getParam("step", 1);
      if (this.value < this.getParam("min", 0)) {
        this.value = this.getParam("min", 0);
      }
    },

    datasend(value) {
      this.doPublish({ topic: this.widget.topic, payload: String(value) });
    },

    update() {
      try {
        const nextValue = Number(this.widget.payload);
        this.value = Number.isFinite(nextValue) ? nextValue : this.getParam("value", 0);
        this.min = this.getParam("min", 0);
        this.max = this.getParam("max", 100);
        this.step = this.getParam("step", 1);
        this.decimal = this.getParam("decimal", 0);
      } catch (err) {
        console.log("StepInput", "error", err);
      }
    },

    Display(value) {
      const decimal = this.getParam("decimal", 0);
      return parseFloat(value || 0).toFixed(decimal);
    },
  },

  mounted() {
    this.value = 0;
    this.min = this.getParam("min", 0);
    this.max = this.getParam("max", 100);
    this.step = this.getParam("step", 1);
    this.decimal = this.getParam("decimal", 0);
    this.update();
    this.$store.watch(
      (state) => {
        return state.widgets.filter((d) => d.topic == this.widget.topic);
      },
      () => {
        this.update();
      },
      { deep: true }
    );
  },
};
</script>

<style scoped>
.step-widget {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: #111111;
  text-align: center;
}

.step-widget__value {
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.step-widget__buttons {
  width: 100%;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step-widget__btn {
  margin: 0 !important;
  padding: 0 !important;
  border-radius: 16px !important;
  font-weight: 800 !important;
}
</style>
